import { Info } from "@phosphor-icons/react";

import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

export default function VariablesPreview({
  variables,
}: {
  variables: string[];
}) {
  return (
    <div className="mt-2.5 flex flex-col rounded-3xl border border-black-200">
      {/* Header */}
      <div className="grid w-full grid-cols-2 gap-x-4 lg:gap-x-6 border-b border-black-200 px-3 py-1.5">
        <div className="flex items-center gap-x-0.5 text-xs text-black-700">
          <span>Column</span>
          <Tooltip>
            <TooltipTrigger>
              <Info size={16} weight="fill" className="text-black-500" />
            </TooltipTrigger>
            <TooltipContent>
              Your column names in the uploaded file
            </TooltipContent>
          </Tooltip>
        </div>

        <div className="flex items-center gap-x-0.5 text-xs text-black-700">
          <span>Variable</span>
          <Tooltip>
            <TooltipTrigger>
              <Info size={16} weight="fill" className="text-black-500" />
            </TooltipTrigger>
            <TooltipContent>
              The columns from the uploaded file will be usable as variables in
              the campaign. You must select the identifier column containing
              LinkedIn URLs
            </TooltipContent>
          </Tooltip>
        </div>
      </div>

      {/* Variables */}
      <div className="max-h-[25dvh] overflow-y-auto scrollbar-thin">
        {variables.map((variable) => (
          <div
            key={variable}
            className="grid w-full grid-cols-2 gap-x-4 border-b border-black-200 px-2.5 py-3 last:border-b-0 lg:gap-x-6 lg:px-3 lg:py-4"
          >
            <span className="self-center text-sm-bold text-black-700">
              {variable}
            </span>
            <Tag
              className="w-fit max-w-full self-center"
              variant="info"
              size="lg"
            >
              <span className="truncate">{variable}</span>
            </Tag>
          </div>
        ))}
      </div>
    </div>
  );
}
